import { MaintenanceForwardingCheckinEntryKlass, MaintenanceForwardingCheckinEntryMap } from "./checkinEntries/checkinEntry.type";
import { MaintenanceForwardingDirectiveEntryMap } from "./directiveEntries/directiveEntry.type";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass, MaintenanceForwardingEstablishmentChoiceEntryMap } from './establishmentChoiceEntries/establishmentChoiceEntry.type';
import { MaintenanceFiscalAssessmentEntryData } from "./fiscalAssessmentEntry/fiscalAssessmentEntry.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "./maintenanceForwardingsDirectiveEntryKlasses.type";

export enum MaintenanceForwardingDirectiveEntryStatus {
  Pending = 'pending',
  AwaitingManualStart = 'awaiting_manual_start',
  InProgress = 'in_progress',
  AwaitingClientReview = 'awaiting_client_review',
}

export enum MaintenanceForwardingStatus {
  Canceled = 'canceled',
  ComplementTextField = 'completed',
  OnGoingEstablishmentChoice = 'ongoing_establishment_choice',
  OnGoingCheckin = 'ongoing_checkin',
  OnGoingDirective = 'ongoing_directive',
  OnGoingFinancialReview = 'ongoing_financial_review',
  OnGoingFiscalAssessment = 'ongoing_fiscal_assessment',
  OnGoingCheckout = 'ongoing_checkout',
}

export type MaintenanceForwardingData<
  DirectiveEntry extends MaintenanceForwardingDirectiveEntryMap[MaintenanceForwardingsDirectiveEntryKlass] = never,
  // implement all entries as generics in the future
> = {
  canceled_at: string | null;
  checkin_entry: MaintenanceForwardingCheckinEntryMap[MaintenanceForwardingCheckinEntryKlass.TransportAutoEntry]; // improve with generics in the future
  checkin_entry_type: MaintenanceForwardingCheckinEntryKlass;
  checkout_entry: MaintenanceForwardingCheckinEntryMap[MaintenanceForwardingCheckinEntryKlass.TransportAutoEntry] | null; // improve with generics in the future
  checkout_entry_type: MaintenanceForwardingCheckinEntryKlass | null;
  completed_at: string | null;
  created_at: string;
  directive_entry: DirectiveEntry;
  directive_entry_type: MaintenanceForwardingsDirectiveEntryKlass;
  establishment_choice_entry: MaintenanceForwardingEstablishmentChoiceEntryMap[MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry]; // improve with generics in the future
  establishment_choice_entry_type: MaintenanceForwardingEstablishmentChoiceEntryKlass;
  fiscal_assessment_entry: MaintenanceFiscalAssessmentEntryData;
  fiscal_assessment_entry_type: string;
  id: string;
  status: MaintenanceForwardingStatus;
  updated_at: string;
  workflow: {
    id: string;
  };
}

export type MaintenanceForwardingSectionsProps = {
  forwarding: MaintenanceForwardingData;
}
